(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["color-outfit"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('color-outfit')) {
    customElements.define('color-outfit', class ColorOutfit extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.button = this.querySelector('[data-color-outfit-add]');
        this.error = this.querySelector('[data-color-outfit-error]');
        this.rangeSelect = this.querySelector('[data-color-outfit-range]');
        this.button.addEventListener('click', () => this.addToCart());
        this.rangeSelect.addEventListener('change', () => {
          this.dataset.rangeManuallyChosen = 'true';
          this.dataset.outfitRange = this.rangeSelect.value;
          this.updateSizeText();
          this.querySelector('outfit-color-choices')?.refresh();
        });
        this.handleSourceChange = (event) => {
          const formAttribute = event.target.getAttribute?.('form') || '';
          const formId = event.target.closest?.('form')?.id || '';
          if (formAttribute.includes(this.dataset.sourceProductId) || formId.includes(this.dataset.sourceProductId)) {
            window.setTimeout(() => this.syncSourceSize(), 0);
          }
        };
        document.addEventListener('change', this.handleSourceChange, true);
        this.syncSourceSize();
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.handleSourceChange, true);
      }

      sourceVariantId() {
        const id = this.dataset.sourceProductId;
        const input = document.querySelector(`form[id*="${id}"] input[name="id"]`) ||
          document.querySelector(`input[name="id"][form*="${id}"]`);
        return input?.value || this.dataset.sourceVariantId;
      }

      selectedSourceSize() {
        const id = this.dataset.sourceProductId;
        const checked = document.querySelector(`input[type="radio"][data-option-position="1"][form*="${id}"]:checked`) ||
          document.querySelector(`form[id*="${id}"] input[type="radio"][data-option-position="1"]:checked`);
        const label = checked ? document.querySelector(`label[for="${checked.id}"]`) : null;
        return label?.textContent.match(/\d+\s*\/\s*\d+|\d+\s*[-–]\s*\d/)?.[0]?.replace(/\s/g, '').replace('–', '-') || this.dataset.sourceAge;
      }

      syncSourceSize() {
        const size = this.selectedSourceSize();
        this.dataset.sourceAge = size;
        const primary = this.dataset.primaryFamily;
        const monthly = ['ben', 'lotti'].includes(primary);
        const baby = monthly || primary === 'toni' || primary === 'ida' || size === '0-1' || ['50/56', '62/68', '74/80', '86/92'].includes(size);
        const hatAge = baby ? '0-1' : (size === '3-5' || size === '3-4' || size === '4-5' ? '3-5' : '1-3');
        const allowedRanges = hatAge === '3-5' ? ['3-4', '4-5'] : ['1-2', '2-3'];
        const previousRange = this.dataset.outfitRange;
        const range = monthly ? size : baby ? '0-1' : (primary === 'emma' ? (allowedRanges.includes(previousRange) ? previousRange : allowedRanges[0]) : size);
        const changed = this.dataset.outfitAge !== hatAge || this.dataset.outfitRange !== range || this.dataset.sourceVariantId !== this.sourceVariantId();
        this.dataset.sourceVariantId = this.sourceVariantId();
        this.dataset.outfitAge = monthly ? size : hatAge;
        this.dataset.outfitRange = range;
        this.dataset.outfitAges = baby ? 'baby' : 'older';
        this.hidden = primary === 'paul' && baby;
        this.querySelectorAll('[data-baby-only]').forEach((element) => { element.hidden = !baby; });
        this.querySelectorAll('[data-older-only]').forEach((element) => { element.hidden = baby; });
        const rangePanel = this.querySelector('[data-older-range]');
        rangePanel.hidden = baby || primary !== 'emma';
        if (!rangePanel.hidden) {
          this.rangeSelect.replaceChildren(...allowedRanges.map((value) => {
            const option = document.createElement('option');
            option.value = value;
            option.textContent = this.dataset.rangeLabelTemplate.replace('__RANGE__', value);
            option.selected = value === range;
            return option;
          }));
        }
        this.updateSizeText();
        if (changed) this.querySelector('outfit-color-choices')?.refresh();
      }

      updateSizeText() {
        const monthly = ['ben', 'lotti'].includes(this.dataset.primaryFamily);
        const text = monthly
          ? this.dataset.sourceAge + ' Monate'
          : this.dataset.outfitAge === '0-1'
          ? this.dataset.babySizeText
          : this.dataset.olderSizeTemplate.replace('__HAT__', this.dataset.outfitAge).replace('__RANGE__', this.dataset.outfitRange);
        this.querySelector('[data-color-outfit-size]').textContent = text;
      }

      async addToCart() {
        const button = this.button;
        const ids = this.dataset.customVariantIds;
        if (!ids || button.disabled) return;
        button.disabled = true;
        this.error.hidden = true;
        try {
          const items = ids.split(',').filter(Boolean).map((id) => ({ id: Number(id), quantity: 1 }));
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('cart_add_failed');
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.error.hidden = false;
          button.disabled = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["complete-outfit"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('complete-outfit')) {
    customElements.define('complete-outfit', class CompleteOutfit extends HTMLElement {
      connectedCallback() {
        this.variants = JSON.parse(this.querySelector('[data-outfit-variants]').textContent);
        this.selects = Array.from(this.querySelectorAll('[data-outfit-option]'));
        this.hiddenInput = this.querySelector('[data-outfit-variant-id]');
        this.price = this.querySelector('[data-outfit-price]');
        this.button = this.querySelector('[data-outfit-submit]');
        this.buttonText = this.querySelector('[data-outfit-button-text]');
        this.selects.forEach((select) => select.addEventListener('change', () => this.updateVariant()));
        this.updateVariant();
      }

      formatMoney(cents) {
        if ((document.documentElement.lang || '').toLowerCase().startsWith('de')) {
          return (cents / 100).toFixed(2).replace('.', ',') + ' €';
        }

        return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
          style: 'currency',
          currency: this.dataset.currency || 'EUR'
        }).format(cents / 100);
      }

      updateVariant() {
        const selectedOptions = this.selects.map((select) => select.value);
        const variant = this.variants.find((item) => item.options.every((value, index) => value === selectedOptions[index])) || this.variants[0];
        this.hiddenInput.value = variant.id;
        this.price.textContent = this.formatMoney(variant.price);
        this.button.disabled = !variant.available;
        this.buttonText.textContent = variant.available
          ? this.dataset.addLabel + ' – ' + this.formatMoney(variant.price)
          : this.dataset.soldOutLabel;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gift-set-personalization"] && !Shopify.designMode) return;
  try {
    if (!window.ltGiftSetPersonalizationBound) {
  window.ltGiftSetPersonalizationBound = true;
  document.addEventListener('change', function(event) {
    if (!event.target.matches('[data-gift-set-toggle]')) return;
    const root = event.target.closest('[data-gift-set]');
    const field = root.querySelector('[data-gift-set-text]');
    const selected = event.target.checked;
    root.querySelector('.lt-gift-set__message').hidden = !selected;
    field.disabled = !selected;
    field.required = selected;
    if (!selected) field.value = '';
    root.querySelector('[data-gift-set-count]').textContent = field.value.length;
  });
  document.addEventListener('input', function(event) {
    if (!event.target.matches('[data-gift-set-text]')) return;
    event.target.closest('[data-gift-set]').querySelector('[data-gift-set-count]').textContent = event.target.value.length;
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["outfit-color-select"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('outfit-color-choices')) {
    customElements.define('outfit-color-choices', class OutfitColorChoices extends HTMLElement {
      static products = new Map();

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.card = this.closest('[data-outfit-card]');
        this.controls = [...this.card.querySelectorAll('[data-outfit-part]')];
        this.optionTemplates = new Map(this.controls.map((control) => [
          control,
          [...control.options].map((option) => option.cloneNode(true))
        ]));
        this.button = this.card.querySelector('[data-color-outfit-add]');
        this.controls.forEach((control) => {
          let error = control.parentElement.querySelector('.lt-outfit-color__field-error');
          if (!error) {
            error = document.createElement('span');
            error.className = 'lt-outfit-color__field-error';
            error.setAttribute('role', 'alert');
            error.hidden = true;
            control.after(error);
          }
          control.addEventListener('change', () => {
            this.card.dataset.previewPart = control.value ? control.dataset.outfitPart : '';
            this.card.updateSizeText();
            this.refresh();
          });
        });
        this.status = document.createElement('p');
        this.status.className = 'lt-outfit-color__status';
        this.status.setAttribute('role', 'status');
        this.status.hidden = true;
        this.after(this.status);
        this.refresh();
      }

      static getProduct(handle) {
        if (!handle) return Promise.resolve(null);
        if (!this.products.has(handle)) {
          const root = window.Shopify?.routes?.root || '/';
          const request = fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
            .then((response) => {
              if (!response.ok) throw new Error('product_unavailable');
              return response.json();
            })
            .catch((error) => {
              this.products.delete(handle);
              throw error;
            });
          this.products.set(handle, request);
        }
        return this.products.get(handle);
      }

      ageFor(part) {
        if (['ben', 'lotti'].includes(part)) return this.card.selectedSourceSize();
        if (part === 'ida') return 'blanket';
        if (part === 'toni') return '0-1';
        if (['lorena', 'lara', 'lucia'].includes(part)) return this.card.selectedSourceSize();
        return part === 'emma' ? this.card.dataset.outfitAge : this.card.dataset.outfitRange;
      }

      sourceVariantId() {
        return this.card.sourceVariantId?.() || this.card.dataset.sourceVariantId;
      }

      variantFor(product, part, handle) {
        if (!product) return null;
        const isSource = part === this.card.dataset.primaryFamily && handle === this.card.dataset.sourceProductHandle;
        if (isSource) {
          const sourceId = Number(this.sourceVariantId());
          const sourceVariant = product.variants.find((variant) => Number(variant.id) === sourceId);
          return sourceVariant?.available ? sourceVariant : null;
        }
        if (part === 'ida') {
          return product.variants.find((variant) => variant.available && /100\s*cm|\d+\s*[x×*]\s*100/i.test(variant.title)) ||
            (product.variants.length === 1 && product.variants[0].available ? product.variants[0] : null);
        }
        if (['lorena', 'lara', 'lucia'].includes(part)) {
          const size = this.card.selectedSourceSize();
          const targetSize = size.includes('/') ? size : '50/56';
          return product.variants.find((variant) => variant.available && variant.title.replace(/\s/g, '').includes(targetSize)) || null;
        }
        if (part === 'toni') {
          return product.variants.find((variant) => variant.available) || null;
        }
        const age = this.ageFor(part);
        const normalizedAge = age.replace(/[–—]/g, '-').replace(/\s+/g, '');
        return product.variants.find((variant) => variant.available && variant.title.replace(/[–—]/g, '-').replace(/\s+/g, '').includes(normalizedAge)) || null;
      }

      async filterAvailableOptions(control, revision) {
        const templates = this.optionTemplates.get(control) || [];
        const part = control.dataset.outfitPart;
        const checked = await Promise.all(templates.map(async (option) => {
          if (!option.value) return option;
          const product = await this.constructor.getProduct(option.value).catch(() => null);
          return this.variantFor(product, part, option.value) ? option : null;
        }));
        if (revision !== this.revision) return;

        const selected = control.value;
        const availableOptions = checked.filter(Boolean);
        const selectionStillAvailable = availableOptions.some((option) => option.value === selected);
        control.replaceChildren(...availableOptions.map((option) => option.cloneNode(true)));
        if (selected && selectionStillAvailable) {
          control.value = selected;
        } else if (availableOptions.some((option) => option.value === '')) {
          control.value = '';
          if (selected) this.card.dataset.previewPart = '';
        } else {
          control.selectedIndex = availableOptions.length ? 0 : -1;
          if (selected) this.card.dataset.previewPart = control.value ? part : '';
        }
      }

      selectedColor(control) {
        return control.selectedOptions[0]?.dataset.color || control.selectedOptions[0]?.textContent.trim() || '';
      }

      formatMoney(cents) {
        return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
          style: 'currency',
          currency: this.card.dataset.currency || 'EUR'
        }).format(cents / 100);
      }

      async selectionFor(control) {
        const selectedHandle = control.value;
        const selectedProduct = selectedHandle
          ? await this.constructor.getProduct(selectedHandle).catch(() => null)
          : null;
        const part = control.dataset.outfitPart;
        const selectedVariant = selectedProduct ? this.variantFor(selectedProduct, part, selectedHandle) : null;
        return {
          control,
          part,
          selected: Boolean(selectedHandle),
          selectedProduct,
          selectedVariant
        };
      }

      updatePreview(selections) {
        this.card.querySelectorAll('[data-outfit-name]').forEach((item) => { item.hidden = true; });
        selections.forEach(({ control, part, selected, selectedProduct, selectedVariant }) => {
          if (!selected || !selectedProduct) return;
          const item = this.card.querySelector('[data-outfit-name="' + part + '"]');
          if (!item) return;
          const title = item.querySelector('[data-outfit-title]');
          title.textContent = this.card.dataset.itemTemplate
            .replace('__ITEM__', control.dataset.outfitLabel)
            .replace('__COLOR__', this.selectedColor(control));
          item.hidden = false;
          item.dataset.valid = selectedVariant ? 'true' : 'false';
        });

        const included = selections.filter(({ selected }) => selected);
        this.card.classList.toggle('lt-color-outfit--empty', included.length === 0);
        const emptyMessage = this.card.querySelector('[data-color-outfit-empty]');
        if (emptyMessage) emptyMessage.hidden = included.length !== 0;

        const link = this.card.querySelector('[data-outfit-image-link]');
        const hero = included.find(({ part, selectedProduct }) => part === this.card.dataset.previewPart && selectedProduct) ||
          included.find(({ part, selectedProduct }) => part === this.card.dataset.primaryFamily && selectedProduct) ||
          included.find(({ selectedProduct }) => selectedProduct);
        link.hidden = !hero;
        if (!hero) return;
        link.href = hero.selectedProduct.url;
        link.setAttribute('aria-label', hero.control.dataset.outfitLabel + ' ' + this.selectedColor(hero.control));
        const photo = link.querySelector('img');
        const variantImage = hero.selectedVariant?.featured_image?.src || hero.selectedVariant?.featured_image;
        const image = variantImage || hero.selectedProduct.featured_image;
        if (photo && image) {
          photo.src = typeof image === 'string' ? image : image.src;
          photo.removeAttribute('srcset');
          photo.alt = hero.control.dataset.outfitLabel + ' in ' + this.selectedColor(hero.control);
        }
      }

      updateErrors(selections) {
        selections.forEach(({ control, selected, selectedVariant }) => {
          const error = control.parentElement.querySelector('.lt-outfit-color__field-error');
          const invalid = selected && !selectedVariant;
          control.toggleAttribute('aria-invalid', invalid);
          error.textContent = invalid ? control.dataset.outfitLabel + ': ' + this.dataset.unavailable : '';
          error.hidden = !invalid;
        });
      }

      updatePrices(selections) {
        const customEntries = selections.filter(({ selectedVariant }) => selectedVariant);
        const customPrice = customEntries.reduce((sum, { selectedVariant }) => sum + selectedVariant.price, 0);

        this.card.dataset.customVariantIds = customEntries.map(({ selectedVariant }) => selectedVariant.id).join(',');
        this.card.querySelector('[data-color-outfit-price]').textContent = this.formatMoney(customPrice);
        this.button.disabled = customEntries.length === 0;
      }

      async refresh() {
        const revision = this.revision = (this.revision || 0) + 1;
        this.button.disabled = true;
        this.status.hidden = false;
        this.status.dataset.loading = '';
        this.status.textContent = this.dataset.loading;
        this.card.querySelector('[data-color-outfit-error]')?.setAttribute('hidden', '');
        try {
          const activeControls = this.controls.filter((control) => {
            const ageGroup = control.closest('[data-baby-only], [data-older-only]');
            return !ageGroup?.hidden;
          });
          await Promise.all(activeControls.map((control) => this.filterAvailableOptions(control, revision)));
          if (revision !== this.revision) return;
          const selections = await Promise.all(activeControls.map((control) => this.selectionFor(control)));
          this.updatePreview(selections);
          this.updateErrors(selections);
          this.updatePrices(selections);
          this.status.hidden = true;
        } catch (error) {
          if (revision !== this.revision) return;
          this.card.dataset.customVariantIds = '';
          this.button.disabled = true;
          this.status.removeAttribute('data-loading');
          this.status.textContent = this.dataset.unavailable;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
